<template>
  <div class="bon-detail" v-if="detail != null">
    <Toast />

    <div class="card">
      <div class="card-header">
        <div class="header-content">
          <h5 class="card-title">BON MUTASI KELUAR GUDANG</h5>
          <Button
            icon="pi pi-arrow-left"
            label="Kembali"
            class="p-button-text"
            @click="$router.push({ name: 'bon-list' })"
          />
        </div>
      </div>

      <div class="card-body">
        <div class="summary-grid">
          <div class="summary-item">
            <label class="summary-label">Nomor Bon</label>
            <div class="summary-value font-medium">
              {{ detail.summary.doc_number }}
            </div>
          </div>

          <div class="summary-item">
            <label class="summary-label">Tanggal Bon</label>
            <div class="summary-value">
              {{ moment(detail.summary.doc_date).format('DD-MM-YYYY') }}
            </div>
          </div>

          <div class="summary-item">
            <label class="summary-label">Nama Toko</label>
            <div class="summary-value">{{ detail.summary.outlet_name }}</div>
          </div>

          <div class="summary-item">
            <label class="summary-label">Type Mutasi</label>
            <div class="summary-value">
              <span
                :class="[
                  'type-badge',
                  `type-${getTypeSeverity(detail.summary.type)}`
                ]"
              >
                {{ detail.summary.type }}
              </span>
            </div>
          </div>
        </div>

        <DataTable
          :value="detail.outlet_inbounds"
          :paginator="false"
          class="p-datatable-sm"
          :loading="loading"
          :scrollable="true"
          scrollHeight="400px"
        >
          <Column field="no" header="No.">
            <template #body="slotProps">
              {{ slotProps.index + 1 }}
            </template>
          </Column>

          <Column field="item_code" header="Barcode">
            <template #body="slotProps">
              <span class="font-medium">{{ slotProps.data.item_code }}</span>
            </template>
          </Column>

          <Column field="category_code" header="Kategori" />
          <Column field="supplier_code" header="Supplier" />

          <Column field="item_name" header="Nama Barang">
            <template #body="slotProps">
              <span class="text-truncate">{{ slotProps.data.item_name }}</span>
            </template>
          </Column>

          <Column field="discount" header="Disc %">
            <template #body="slotProps">
              <span class="text-right">{{ slotProps.data.discount }}%</span>
            </template>
          </Column>

          <Column field="price" header="Harga (Rp.)">
            <template #body="slotProps">
              <span class="text-right font-medium">{{
                slotProps.data.price | currency
              }}</span>
            </template>
          </Column>

          <Column field="qty" header="Jumlah">
            <template #body="slotProps">
              <span class="text-right">{{ slotProps.data.qty }}</span>
            </template>
          </Column>

          <Column field="total" header="Total (Rp.)">
            <template #body="slotProps">
              <span class="text-right font-medium">{{
                slotProps.data.total | currency
              }}</span>
            </template>
          </Column>
        </DataTable>

        <div class="summary-row">
          <div class="summary-total">
            <span class="total-label">Total</span>
            <div class="total-values">
              <span class="total-qty"
                >{{ detail.summary.total_qty }} items</span
              >
              <span class="total-price">{{
                detail.summary.total_price | currency
              }}</span>
            </div>
          </div>
        </div>

        <div class="action-buttons">
          <Button
            icon="pi pi-print"
            label="Print"
            class="p-button-primary"
            @click="
              $router.push({
                name: 'print-receiving',
                params: { detail: detail }
              })
            "
          />
          <Button
            icon="pi pi-file"
            label="Export CSV"
            class="p-button-primary"
            @click="getBonReceivingCSV()"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
let moment = require('moment')

export default {
  data() {
    return {
      moment: moment,
      loading: true,
      products: null,
      expandedRows: [],
      detail: null
    }
  },
  mounted() {
    this.getOutlets()
  },
  methods: {
    getTypeSeverity(type) {
      console.log('Type value:', type)
      const types = {
        'MUTASI KELUAR': 'warn',
        'MUTASI MASUK': 'success',
        REGULAR_MUTATION: 'info',
        SPECIAL_MUTATION: 'warn',
        SALE_MUTATION: 'success',
        GIFT_MUTATION: 'info'
      }
      return types[type] || 'info'
    },
    getStatusSeverity(status) {
      const statuses = {
        ACTIVE: 'success',
        INACTIVE: 'danger',
        PENDING: 'warning'
      }
      return statuses[status] || 'info'
    },
    async getOutlets() {
      this.loading = true
      try {
        const response = await this.$http.get(
          `${process.env.VUE_APP_API_URL}/dashboard/outlet-inbound`,
          {
            params: {
              doc_number: this.$route.query.doc_number
            }
          }
        )

        if (response.status === 200) {
          this.detail = response.data.data
        } else {
          this.$toast.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Failed to fetch data'
          })
          console.error('Error when fetch get outlet : ', response.data)
        }
      } catch (error) {
        console.error('Error fetching outlet data:', error)
        this.$toast.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to fetch data'
        })
      } finally {
        this.loading = false
      }
    },

    async getBonReceivingCSV() {
      try {
        const response = await this.$http.get(
          `${process.env.VUE_APP_API_URL}/dashboard/outlet-inbounds/csv`,
          {
            params: {
              doc_number: this.$route.query.doc_number
            },
            responseType: 'blob'
          }
        )

        if (response.status === 200) {
          const blob = new Blob([response.data], {
            type: response.headers['content-type']
          })
          const link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = `BONRECEIVING_${this.detail.summary.doc_number}.csv`
          link.click()

          this.$toast.add({
            severity: 'success',
            summary: 'Success',
            detail: 'CSV exported successfully'
          })
        } else {
          this.$toast.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Failed to export CSV'
          })
          console.error('Error get bon receive : ', response.data)
        }
      } catch (error) {
        console.error('Error exporting CSV:', error)
        this.$toast.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to export CSV'
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.bon-detail {
  .card {
    background: #ffffff;
    border-radius: 6px;
    box-shadow: 0 2px 1px -1px rgba(0, 0, 0, 0.2),
      0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 1px 3px 0 rgba(0, 0, 0, 0.12);

    .card-header {
      padding: 1.5rem;
      border-bottom: 1px solid #dee2e6;

      .header-content {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .card-title {
          margin: 0;
          font-size: 1.5rem;
          font-weight: 600;
          color: #495057;
        }
      }
    }

    .card-body {
      padding: 1.5rem;
    }
  }

  .summary-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 1.5rem;
    margin-bottom: 2rem;
  }

  .summary-item {
    .summary-label {
      display: block;
      font-size: 0.875rem;
      color: #6c757d;
      margin-bottom: 0.5rem;
    }

    .summary-value {
      font-size: 1rem;
      color: #495057;
    }
  }

  .summary-row {
    margin-top: 1rem;
    padding: 1rem;
    background-color: #f8f9fa;
    border-radius: 4px;

    .summary-total {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      gap: 1rem;

      .total-label {
        font-size: 1rem;
        font-weight: 600;
        color: #495057;
      }

      .total-values {
        display: flex;
        align-items: center;
        gap: 2rem;

        .total-qty {
          font-size: 1rem;
          color: #6c757d;
        }

        .total-price {
          font-size: 1.25rem;
          font-weight: 600;
          color: #2196f3;
        }
      }
    }
  }

  .action-buttons {
    display: flex;
    gap: 1rem;
    margin-top: 2rem;
    justify-content: flex-end;
  }

  :deep(.p-datatable) {
    .p-datatable-thead > tr > th {
      background-color: #f8f9fa;
      padding: 0.75rem;
      font-size: 0.875rem;
      font-weight: 600;
      color: #495057;
      text-align: center !important;

      &:nth-child(1) {
        width: 5%;
      } /* No. */
      &:nth-child(2) {
        width: 15%;
      } /* Kode Barang */
      &:nth-child(3) {
        width: 10%;
      } /* Kode Kategori */
      &:nth-child(4) {
        width: 10%;
      } /* Kode Supplier */
      &:nth-child(5) {
        width: 20%;
      } /* Nama Barang */
      &:nth-child(6) {
        width: 10%;
      } /* Disc % */
      &:nth-child(7) {
        width: 15%;
      } /* Harga (Rp.) */
      &:nth-child(8) {
        width: 10%;
      } /* Jumlah */
      &:nth-child(9) {
        width: 15%;
      } /* Total (Rp.) */
    }

    .p-datatable-tbody > tr > td {
      padding: 0.75rem;
      font-size: 0.875rem;
      background: #ffffff;

      &:nth-child(1) {
        width: 5%;
      } /* No. */
      &:nth-child(2) {
        width: 15%;
      } /* Barcode */
      &:nth-child(3) {
        width: 10%;
        text-align: center;
      } /* Kategori */
      &:nth-child(4) {
        width: 10%;
        text-align: center;
      } /* Supplier */
      &:nth-child(5) {
        width: 20%;
      } /* Nama Barang */
      &:nth-child(6) {
        width: 10%;
      } /* Disc % */
      &:nth-child(7) {
        width: 15%;
        text-align: right;
      } /* Harga (Rp.) */
      &:nth-child(8) {
        width: 10%;
        text-align: right;
      } /* Jumlah */
      &:nth-child(9) {
        width: 15%;
        text-align: right;
      } /* Total (Rp.) */

      &.text-right {
        text-align: right;
      }
    }

    .p-datatable-tbody > tr:hover {
      background-color: rgba(0, 0, 0, 0.02);
    }
  }

  .text-truncate {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
    display: inline-block;
  }

  .font-medium {
    font-weight: 500;
  }

  .type-badge {
    display: inline-block;
    padding: 0.1rem 0.1rem;
    border-radius: 0.25rem;
    font-size: 0.8rem;
    font-weight: 500;
    line-height: 1.2;

    &.type-info {
      background: #e3f2fd;
      color: #1976d2;
    }
    &.type-success {
      background: #e8f5e9;
      color: #2e7d32;
    }
    &.type-warn {
      background: #fff3e0;
      color: #e65100;
    }
    &.type-error {
      background: #ffebee;
      color: #c62828;
    }
  }
}
</style>
